import { Controls, ControlsButton } from "@/components/Controls";
import { TableHeader, Th } from "@/components/Table";
import { DateTime } from "luxon";
import { ReactNode, useState } from "react";
import styled from "styled-components";

import ParticipantsScoreDateFilter, {
  months,
} from "./ParticipantsScoreDateFilter";
import ParticipantsScoreSequenceFilter from "./ParticipantsScoreSequenceFilter";
import ScoreByActivity from "./ScoreByActivity";
import ScoreByCtr from "./ScoreByCtr";
import ScoreByWins from "./ScoreByWins";

enum Tabs {
  Wins = "Wins",
  Ctr = "Ctr",
  Activity = "Activity",
}

const FilterHolder = styled.div`
  display: flex;
  align-items: center;
`;

const ScoreTables = () => {
  const [activePeriod, setActivePeriod] = useState<string>(
    months[0].startOf("month").toFormat("yyyy-LL-dd")
  );

  const [sequenceValue, setSequenceValue] = useState<{
    value: number | "All";
    type: string;
  }>({
    value: "All",
    type: "",
  });

  const [activeTab, setActiveTab] = useState(Tabs.Wins);

  const startDt = DateTime.fromFormat(activePeriod, "yyyy-LL-dd");
  const endDt = DateTime.fromFormat(activePeriod, "yyyy-LL-dd").endOf("month");

  const renderThs = () => {
    const components: ReactNode[] = [];

    let days = 0;

    while (startDt.plus({ days }).toFormat("dd") <= endDt.toFormat("dd")) {
      components.push(
        <Th key={days}>{startDt.plus({ days }).toFormat("LL-dd")}</Th>
      );

      days++;

      if (days === parseInt(endDt.toFormat("dd"))) {
        break;
      }
    }

    return components;
  };

  return (
    <>
      <TableHeader>
        <Controls>
          <ControlsButton
            active={activeTab === Tabs.Wins}
            onClick={() => setActiveTab(Tabs.Wins)}
          >
            By Wins
          </ControlsButton>
          <ControlsButton
            active={activeTab === Tabs.Ctr}
            onClick={() => setActiveTab(Tabs.Ctr)}
          >
            By Top CTR (%)
          </ControlsButton>
          <ControlsButton
            active={activeTab === Tabs.Activity}
            onClick={() => setActiveTab(Tabs.Activity)}
          >
            By Activity
          </ControlsButton>
        </Controls>
        <FilterHolder>
          <ParticipantsScoreSequenceFilter
            sequenceValue={sequenceValue}
            setSequenceValue={setSequenceValue}
          />
          <ParticipantsScoreDateFilter
            activePeriod={activePeriod}
            setActivePeriod={setActivePeriod}
          />
        </FilterHolder>
      </TableHeader>
      {activeTab === Tabs.Wins && (
        <ScoreByWins
          activePeriod={activePeriod}
          startDt={startDt}
          endDt={endDt}
          renderThs={renderThs}
          sequenceValue={sequenceValue}
        />
      )}
      {activeTab === Tabs.Ctr && (
        <ScoreByCtr
          activePeriod={activePeriod}
          startDt={startDt}
          endDt={endDt}
          renderThs={renderThs}
          sequenceValue={sequenceValue}
        />
      )}
      {activeTab === Tabs.Activity && (
        <ScoreByActivity
          activePeriod={activePeriod}
          startDt={startDt}
          endDt={endDt}
          renderThs={renderThs}
          sequenceValue={sequenceValue}
        />
      )}
    </>
  );
};

export default ScoreTables;
